import assetApi from '@Apis/assets.api';
import inspectionApi from '@Apis/inspection.api';
import riskApi from '@Apis/risks.api';
import {
	AssetDetailParams,
	AssetManholeSummary,
} from '@innovyze/lib-am-common/types/asset.types';
import {
	GetInspListParams,
	InspectionParams,
	InspectionResolvedResponse,
} from '@innovyze/lib-am-common/types/inspectionAttributes.types';

export const debounce = <F extends (...args: unknown[]) => unknown>(
	func: F,
	waitFor: number,
) => {
	let timeout = 0;

	const debounced = (...args: unknown[]) => {
		clearTimeout(timeout);
		timeout = window.setTimeout(() => func(...args), waitFor);
	};

	return debounced;
};

export const getInspectionsApi = (params: InspectionParams) => {
	const address =
		'/inspectionAttributes?assetType=' +
		encodeURIComponent(params.assetType) +
		'&assetId=' +
		encodeURIComponent(params.assetId);

	const response = inspectionApi.get<InspectionResolvedResponse>(address);
	return response;
};

export const getSummaryApi = (assetParams: AssetDetailParams) => {
	const address = `/assets/${encodeURIComponent(
		assetParams.assetId,
	)}?assetType=${assetParams.assetType}`;

	return assetApi.get<AssetManholeSummary>(address);
};

export const getInspectionApi = (assetId: string) => {
	const address = `/inspections/${encodeURIComponent(assetId)}`;
	return inspectionApi.get<GetInspListParams>(address);
};

export const getRiskApi = ({ assetType, assetId }: AssetDetailParams) => {
	const newAssetID = encodeURIComponent(`${assetType}#${assetId}`);
	const address = `/risk/singlescore/${newAssetID}`;
	return riskApi.get(address);
};
